import { useState } from "react";
import { Button, BUTTON_SIZE, BUTTON_VARIANT } from "components/UI/Button";
import { Input } from "components/UI/Input";
import { useAppDispatch } from "hooks/useAppDispatch";
import { useTranslation } from "localization/localization";
import { PalletRow } from "models/packingList";
import { addCustomPallet, updateCustomPallet, updatePalletRow } from "store";
import s from "./PalletTable.module.scss";

interface PalletSaveContentProps {
  groupId: string;
  row: PalletRow;
  editPalletId?: string;
  onClose: () => void;
}

export const PalletSave = ({ groupId, row, editPalletId, onClose }: PalletSaveContentProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isEdit = Boolean(editPalletId);
  const [name, setName] = useState(row.palleteName ?? "");

  const handleSave = () => {
    if (!name.trim()) return;

    const palleteName = name.trim();

    if (isEdit && editPalletId) {
      dispatch(
        updateCustomPallet({
          ...row,
          id: editPalletId,
          palletType: editPalletId,
          palleteName,
        })
      );
      onClose();
      return;
    }

    const id = crypto.randomUUID();
    dispatch(addCustomPallet({ ...row, id, palleteName }));
    dispatch(updatePalletRow({ groupId, palletType: id, palleteName }));
    onClose();
  };

  return (
    <div className={s.saveModal}>
      <p className={s.title}>{t(isEdit ? "Edit Custom pallet" : "Save Custom pallet")}</p>

      <Input
        label={t("Name")}
        placeholder={t("Write name pallet")}
        value={name}
        onChange={(e) => setName(e.target.value)}
      />

      <div className={s.btns}>
        <Button variant={BUTTON_VARIANT.SECONDARY} size={BUTTON_SIZE.L} onClick={onClose}>
          {t("Cancel")}
        </Button>
        <Button size={BUTTON_SIZE.L} onClick={handleSave}>
          {t(isEdit ? "Update" : "Save")}
        </Button>
      </div>
    </div>
  );
};
